<template functional>
  <div class="col mt-2 px-2">
    <icon
      v-if="props.icon"
      :name="props.icon"
      :class="[$style.icon, 'text-muted mb-1 mt-2']"
    />
    <small class="text-muted smaller font-weight-bold d-block">
      <slot name="title">{{ props.title }}</slot>
    </small>
    <div class="border rounded py-1 mt-1 d-block">
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FactItem'
}
</script>

<style lang="scss" module>
.icon {
  width: 2rem;
  height: 2rem;
}
</style>
